export default __webpack_public_path__ + "static/media/noTimeSlots.f77ee142.svg";